module.exports = __webpack_public_path__ + "img/Offre_Speciale.1dc36242.png";